import { Box, Typography } from '@mui/material';
import { isBlockingSlot, localIsoDate } from '../utils/scheduleUtils';

/**
 * Day picker for the resource board, which shows one day at a time. The classic column view
 * does not need it — it renders every fetched day side by side.
 */
export const DaySelector = ({ dailySchedules, selectedDate, onSelect }) => {
  const today = localIsoDate();

  return (
    <Box sx={{ display: 'flex', gap: 1, overflowX: 'auto', pb: 0.5 }}>
      {dailySchedules.map((dailySchedule) => {
        const isSelected = dailySchedule.date === selectedDate;
        const isToday = dailySchedule.date === today;
        // A blocked period is the tenant's own time off, not a guest's booking (as in D24's notice),
        // and the card says nothing about it: the board shows it.
        const bookingCount = (dailySchedule.timeSlots || []).filter((slot) => !isBlockingSlot(slot)).length;

        return (
          <Box
            key={dailySchedule.date}
            onClick={() => onSelect(dailySchedule.date)}
            role="button"
            aria-pressed={isSelected}
            tabIndex={0}
            data-testid="day-selector-day"
            data-date={dailySchedule.date}
            onKeyDown={(event) => {
              if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                onSelect(dailySchedule.date);
              }
            }}
            sx={{
              flex: '0 0 auto',
              minWidth: 108,
              px: 1.5,
              py: 1,
              borderRadius: '8px',
              cursor: 'pointer',
              bgcolor: '#fff',
              border: isSelected ? '1px solid #2196f3' : '1px solid #ddd',
              boxShadow: isSelected ? '0 0 0 1px #2196f3' : 'none',
              transition: 'border-color 0.15s, box-shadow 0.15s',
              '&:hover': { borderColor: '#2196f3' },
              '&:focus-visible': { outline: '2px solid #2196f3', outlineOffset: '2px' },
            }}
          >
            <Typography
              sx={{
                fontSize: '13px',
                fontWeight: 700,
                textTransform: 'capitalize',
                color: isSelected ? '#0d47a1' : '#333',
              }}
            >
              {dailySchedule.weekday}
            </Typography>
            <Typography sx={{ fontSize: '11px', color: '#888', whiteSpace: 'nowrap' }}>
              {dailySchedule.formattedDate}
              {isToday ? ' · ma' : ''}
            </Typography>
            <Typography data-testid="day-selector-summary" sx={{ fontSize: '10.5px', color: bookingCount ? '#555' : '#bbb' }}>
              {bookingCount ? `${bookingCount} foglalás` : 'nincs foglalás'}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default DaySelector;
